export const PLATFORMS = {
  MOBILE_WEB: 'mobilewebapp',
  EMBED: 'embedwebapp',
  PUBLICEMBED: 'publicembedwebapp',
};

export const ADOBE_ANALYTICS_CONFIG = {
  PLATFORM: 'mobilewebapp',
  DTM_TRACK_TYPE: 'link',
};

export const DESKTOP_ANALYTICS_EVENTS = {
  ENVIRONMENT__JUST_SIGNED_IN: 'justSignedIn',
};

export const ADOBE_ANALYTICS_EVENTS = {
  // ENVIRONMENT
  ENVIRONMENT__LOGIN: 'login',
  // GENERAL
  GENERAL__NAVIGATE: 'navigate',
  // UI SECTIONS
  SECTIONS__HOME: 'home_menu',
  HOME__BOOKMARK_ADD: 'home_bookmark_add',
  HOME__BOOKMARK_CLICK: 'home_bookmark_click',
  HOME__BOOKMARK_DELETE: 'home_bookmark_delete',
  HOME__BOOKMARK_EDIT: 'home_bookmark_edit',
  HOME__BOOKMARK_REORDER: 'home_bookmark_reorder',
  HOME__BOOKMARK_SEARCH: 'home_bookmark_search',
  HOME__BUZZ: 'home_buzz',
  SECTIONS__PAGES: 'pages_view',
  PAGE__VIEW: 'page_view',
  CARD__RENDER: 'card_render',
  CARD__ANALYZER: 'card_analyzer_use',
  CARD__DATE_GRAIN: 'card_choose_date_field',
  CARD__FAVORITE: 'card_favorite',
  CARD__NEXT: 'card_next',
  CARD__PREVIOUS: 'card_previous',
  CARD__TABLE_VIEW: 'card_view_detail_table_view',
  CARD__VIEW: 'card_view',
  CARD__DETAILS_SAVE_AS: 'save_as_card',
  CARD__ABOUT: 'card_about',
  CARD__BUZZ: 'card_buzz',
  CARD__JS_API_FILTER: 'card_js_api_filter',
  PUBLIC__CARD__VIEW: 'card_landing_page_view',
  PUBLIC__CARD__CHART__TOGGLE: 'card_landing_page_chart_toggle',
  PUBLIC__CARD__TABLE__TOGGLE: 'card_landing_page_table_toggle',
  PUBLIC__CARD__TRY__CLICK: 'card_landing_page_try_click',
  PUBLIC__CARD__DOMO__CLICK: 'card_landing_page_domo_click',
  PUBLIC__CARD__DRILL: 'card_landing_page_drill',
  PUBLIC__CARD__POP__DRILL: 'card_landing_page_pop_drill',
  PUBLIC__CARD__TWITTER__CLICK: 'card_landing_page_twitter_click',
  PUBLIC__CARD__FACEBOOK__CLICK: 'card_landing_page_facebook_click',
  PUBLIC__CARD__LINKEDIN__CLICK: 'card_landing_page_linkedin_click',
  PUBLIC__CARD__GOOGLE__CLICK: 'card_landing_page_google_click',
  PUBLIC__CARD__PINTEREST__CLICK: 'card_landing_page_pinterest_click',
  SECTIONS__BUZZ: 'buzz_menu_viewed',
  BUZZ__ADD_ATTACHMENT: 'buzz_add_attachment',
  BUZZ__AT_MENTION: 'buzz_at_mention',
  BUZZ__CHANNEL_MEMBERS_VIEWED: 'buzz_channel_members_viewed',
  BUZZ__CHAT_BROWSER_SEARCH: 'buzz_chat_browser_search',
  BUZZ__CHAT_BROWSER_VIEWED: 'buzz_chat_browser_viewed',
  BUZZ__CONVERSATION_VIEWED_DIRECT: 'buzz_conversation_viewed_direct',
  BUZZ__CONVERSATION_VIEWED_GROUP: 'buzz_conversation_viewed_group',
  BUZZ__CONVERSATION_VIEWED_OBJECT_CHANNEL:
    'buzz_conversation_viewed_object_channel',
  BUZZ__CONVERSATION_VIEWED_PUBLIC_CHANNEL:
    'buzz_conversation_viewed_public_channel',
  BUZZ__DATA_ADD_CHAT_BUTTON_CLICK: 'buzz_data_add_chat_button_click',
  BUZZ__DATA_ADD_CHAT_SEARCH: 'buzz_data_add_chat_search',
  BUZZ__FEED_CONVERSATION_VIEW: 'buzz_feed_conversation_view',
  BUZZ__FEED_VIEW: 'buzz_feed_view',
  BUZZ__FOLDER_DATA_VIEW: 'buzz_folder_data_view',
  BUZZ__FOLDER_FAVORITES_VIEW: 'buzz_folder_favorites_view',
  BUZZ__FOLDER_PEOPLE_VIEW: 'buzz_folder_people_view',
  BUZZ__HIDE_CHANNEL: 'buzz_hide_channel',
  BUZZ__JOIN_VIDEO_CHAT: 'buzz_join_video_chat',
  BUZZ__MESSAGE_ADD_REACTION: 'buzz_hover_add_reaction',
  BUZZ__MESSAGE_CREATED_DIRECT: 'buzz_message_created_direct',
  BUZZ__MESSAGE_CREATED_GROUP: 'buzz_message_created_group',
  BUZZ__MESSAGE_CREATED_OBJECT_CHANNEL: 'buzz_message_created_object_channel',
  BUZZ__MESSAGE_CREATED_PUBLIC_CHANNEL: 'buzz_message_created_public_channel',
  BUZZ__MESSAGE_CREATE_HUDDLE: 'buzz_create_topic_from_message',
  BUZZ__MESSAGE_DELETED: 'buzz_message_deleted',
  BUZZ__MESSAGE_FAVORITE: 'buzz_favorite_message',
  BUZZ__MESSAGE_LIKE: 'buzz_hover_like',
  BUZZ__MESSAGE_REPLY: 'buzz_message_reply',
  BUZZ__NEW_CHAT: 'buzz_new_chat',
  BUZZ__NEW_TOPIC: 'buzz_new_topic',
  BUZZ__OPTIONS_MENU: 'buzz_options_menu',
  BUZZ__PEOPLE_ADD_CHAT_BUTTON_CLICK: 'buzz_people_add_chat_button_click',
  BUZZ__PEOPLE_ADD_CHAT_SEARCH: 'buzz_people_add_chat_search',
  BUZZ__REACTIONS_USED_BY_TYPE: 'buzz_reactions_used_by_type',
  BUZZ__TOPIC_BROWSER_VIEWED: 'buzz_topic_browser_viewed',
  BUZZ__TOPIC_PINNED: 'buzz_topic_joined',
  BUZZ__TOPIC_PREVIEWED: 'buzz_topic_previewed',
  SECTIONS__DOMOBUZZ: 'domobuzz_toggle',
  SECTIONS__PEOPLE: 'admin_people',
  PEOPLE__ORG_CHART: 'profile_org_chart_view',
  PEOPLE__ADMIN_GROUPS: 'admin_groups',
  PEOPLE__PROFILE: 'profile_tab',
  PEOPLE__PROFILE_STATS: 'profile_stats',
  SECTIONS__SEARCH: 'search_opened',
  SEARCH__SEARCH_EXECUTED: 'search_executed',
  SEARCH__SEARCH_FACET_SELECTED: 'search_facet_selected',
  SEARCH__SEARCH_FACET_REMOVED: 'search_facet_removed',
  SEARCH__SEARCH_RESULT_CLICKED: 'search_result_clicked',
  SECTIONS__MORE: 'admin_tools',
  // Notification Settings
  NOTIFICATION_SETTINGS_BUZZ: 'notification_settings_buzz',
  NOTIFICATION_SETTINGS_PRODUCTIVITY: 'notification_settings_productivity',
  // SOCIAL USER
  SOCIAL_USER__ATTEMPTED_ROUTE_TO_CARD: 'social_attempted_route_to_card',
  SOCIAL_USER__ATTEMPTED_ROUTE_TO_PAGE: 'social_attempted_route_to_page',
  SOCIAL_USER__BENEFITS_COMPARISON: 'social_benefits_comparison',
  SOCIAL_USER__TRIAL_STARTED: 'social_trial_started',
  SOCIAL_USER__TRIAL_STARTED_CONFIRMED: 'social_trial_started_confirmed',
  SOCIAL_USER__UPGRADE_REQUESTED: 'social_upgrade_requested',
  // INVITE
  INVITE__OPEN_GLOBAL_SEARCH: 'invite_open_global_search',
  INVITE__OPEN_PEOPLE_SEARCH_HEADER: 'invite_open_people_search_header',
  INVITE__OPEN_PEOPLE_SEARCH_NO_RESULTS: 'invite_open_people_no_results',
  INVITE__SUBMIT_GLOBAL_SEARCH: 'invite_submit_global_search',
  INVITE__SUBMIT_PEOPLE_SEARCH_HEADER: 'invite_send_people_search_header',
  INVITE__SUBMIT_PEOPLE_SEARCH_NO_RESULTS: 'invite_send_people_no_results',
  INVITE__EMAIL_BANNER: 'buzz_invite_email_banner',
  // Business-in-a-Box
  BIB__HOME: 'bib_home',
  BIB__PAGE: 'bib_page',
  BIB__DEPARTMENT: 'bib_department',
  BIB__DEPARTMENT_PAGE: 'bib_department_page',
  BIB__APP: 'bib_app',
  BIB__APP_PAGE_POWER: 'bib_apppage_power',
  BIB__APP_CARD_POWER: 'bib_appcard_power',
  BIB__POWER_NOT_NOW: 'bib_power_not_now',
  BIB__POWER_ASSIGN_SENT: 'bib_power_assign_sent',
  BIB__APP_REQUEST: 'bib_app_request',
  BIB__SELECT_INDUSTRY: 'bib_selectindustry',
  // Push to native
  NATIVE_PUSH__SCREEN: 'native_push_screen',
  NATIVE_PUSH__IOS: 'native_push_ios',
  NATIVE_PUSH__GOOGLE_PLAY: 'native_push_google_play',
  //Scheduled Reports
  SCHEDULED_REPORT__CARD_VIEW: 'scheduled_report_card_view',
  SCHEDULED_REPORT__PAGE_VIEW: 'scheduled_report_page_view',

  INTERSTITIAL__CLOSE: 'login_interstitial_close',
  INTERSTITIAL__DONE: 'login_interstitial_done',
  INTERSTITIAL__SLIDE_1: 'login_interstitial1',
  INTERSTITIAL__SLIDE_2: 'login_interstitial2',
  INTERSTITIAL__SLIDE_3: 'login_interstitial3',
  INTERSTITIAL__SLIDE_4: 'login_interstitial4',
  INTERSTITIAL__SLIDE_5: 'login_interstitial5',
};
